module.exports = __webpack_public_path__ + "img/29.66ae2516.jpg";